import { render, staticRenderFns } from "./RankingUser.vue?vue&type=template&id=380bcede&scoped=true"
import script from "./RankingUser.vue?vue&type=script&lang=ts"
export * from "./RankingUser.vue?vue&type=script&lang=ts"
import style0 from "./RankingUser.scss?vue&type=style&index=0&id=380bcede&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380bcede",
  null
  
)

export default component.exports